import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bea41b3a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "page_header" };
const _hoisted_2 = { class: "fixed" };
const _hoisted_3 = { class: "content" };
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = { key: 0 };
import { onMounted } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'page_header',
    props: {
        d: {}
    },
    setup(__props) {
        onMounted(() => {
            function checkContentAbove() {
                const showcaseHeroElement = document.querySelector('.page_header');
                if (showcaseHeroElement) {
                    // Get the position of the page header relative to the viewport
                    const showcaseHeroRect = showcaseHeroElement.getBoundingClientRect();
                    if (showcaseHeroRect.top <= -1000) {
                        showcaseHeroElement.style.zIndex = '-3';
                        showcaseHeroElement.style.opacity = '0';
                    }
                    else {
                        showcaseHeroElement.style.zIndex = 'auto';
                        showcaseHeroElement.style.opacity = '1';
                    }
                }
            }
            // Call the function initially to check the content position
            checkContentAbove();
            // Attach scroll event listener to check the content position when scrolling
            window.addEventListener('scroll', checkContentAbove);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h1", {
                            class: _normalizeClass({ 'page_header__bold': _ctx.d.font_style === 'Bold & Capitalised' })
                        }, [
                            _createElementVNode("span", {
                                innerHTML: _ctx.d.line_one
                            }, null, 8, _hoisted_4),
                            _hoisted_5,
                            _createElementVNode("span", {
                                class: "page_header__bold--black",
                                innerHTML: _ctx.d.line_two
                            }, null, 8, _hoisted_6)
                        ], 2),
                        (_ctx.d.line_two)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.d.line_three), 1))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]));
        };
    }
});
